module.exports = __webpack_public_path__ + "static/img/Craig-Goodwin.c94004b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Craig-Goodwin.jpg
// module id = TCLI
// module chunks = 0